import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  searchTerm: '',
  searchType: '',
};

const searchSlice = createSlice({
  name: 'searchSlice',
  initialState,
  reducers: {
    search(state, action) {
      const { payload = {} } = action;
      const { searchTerm = '', searchType = '' } = payload;
      state.searchTerm = searchTerm;
      state.searchType = searchType;
      return state;
    },
    reset() {
      return { ...initialState };
    },
  },
});

export const selectSearchTerm = state => state.search?.searchTerm;
export const selectSearchType = state => state.search?.searchType;

export const { search, reset } = searchSlice.actions;
export default searchSlice.reducer;
